/**
 * Alert component for displaying messages with different severities.
 */
import * as stylex from "@stylexjs/stylex";

import { colors, fontSize, radius, space } from "../tokens.stylex";

const styles = stylex.create({
  base: {
    marginBottom: space.md,
    borderRadius: radius.md,
    padding: space.md,
    fontSize: fontSize.sm,
  },
  error: {
    backgroundColor: "rgba(239,68,68,0.1)",
    color: colors.destructive,
  },
  success: {
    backgroundColor: "rgba(34,197,94,0.1)",
    color: colors.success,
  },
  warning: {
    backgroundColor: "rgba(234,179,8,0.1)",
    color: colors.warning,
  },
  info: {
    backgroundColor: "rgba(59,130,246,0.1)",
    color: colors.info,
  },
});

type AlertVariant = "error" | "success" | "warning" | "info";

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant;
  xstyle?: stylex.StyleXStyles;
}

function Alert({ variant = "info", xstyle, ...props }: AlertProps) {
  return (
    <div {...stylex.props(styles.base, styles[variant], xstyle)} {...props} />
  );
}

// Export style variants for direct use with stylex.props()
export const alert = styles;

export { Alert, type AlertProps, type AlertVariant };
